<template>
  <div>
    <md-dialog
      :visible.sync="visible"
      top="80px"
      width="520px"
      :title="title"
      :close-on-click-modal="false"
      append-to-body
      :before-close="beforeClose"
    >
      <md-form :model="form" :rules="rules" ref="form" labmd-width="100px" class="my-form" :disabled="readonly">
        <md-form-item label="所属应用">
          <md-input value="GSC" disabled></md-input>
        </md-form-item>
        <md-form-item label="菜单类型" prop="type">
          <md-select v-model="form.type" @change="handleChangeMenuType">
            <md-option label="菜单" value="1"></md-option>
            <md-option label="页面" value="2"></md-option>
          </md-select>
        </md-form-item>
        <md-form-item label="菜单名称" prop="menuNameZh" style="margin-bottom: 0px">
          <md-input v-model="form.menuNameZh">
            <template slot="prepend">中文</template>
            <md-button slot="append" icon="md-icon-plus" @click="addLanguage('name')"></md-button>
          </md-input>
        </md-form-item>
        <md-form-item label="" v-for="item in nameLanguageList" :key="item.model" style="margin-bottom: 0px">
          <md-input v-show="item.show" v-model="form[item.model]">
            <template slot="prepend">{{ item.label }}</template>
            <md-button slot="append" icon="md-icon-plus" @click="addLanguage('name')"></md-button>
            <md-button slot="append" icon="md-icon-minus" @click="deleteLanguage(item)"></md-button>
          </md-input>
        </md-form-item>
        <md-form-item label="唯一标识" prop="menuCode" style="margin-top: 20px">
          <md-input v-model="form.menuCode" :disabled="form.baseMenuId ? true : false"></md-input>
        </md-form-item>
        <md-form-item label="菜单链接" prop="menuUrl" v-if="form.type === '2'">
          <md-input v-model="form.menuUrl"></md-input>
        </md-form-item>
        <md-form-item
          label="是否全集团开放"
          prop="groupMenuFlag"
        >
          <md-select v-model="form.groupMenuFlag">
            <md-option label="是" value="Y"></md-option>
            <md-option label="否" value="N"></md-option>
          </md-select>
        </md-form-item>
        <md-form-item label="菜单图标" prop="iconUrl">
          <md-input v-model="form.iconUrl" @focus="iconChoose">
            <i slot="suffix" class="el-input__icon md-icon-setting" @click="iconChoose"></i>
          </md-input>
        </md-form-item>
        <md-form-item label="排序" prop="sort">
          <md-input v-model="form.sort" style="width: 100px"></md-input>
        </md-form-item>
        <md-form-item label="状态" prop="status">
          <md-switch
            v-model="form.status"
            active-value="Y"
            inactive-value="N"
            activeText="无效"
            inactiveText="有效"
          ></md-switch>
        </md-form-item>
        <md-form-item label="描述" prop="descZh" style="margin-bottom: 0px">
          <md-input v-model="form.descZh">
            <template slot="prepend">中文</template>
            <md-button slot="append" icon="md-icon-plus" @click="addLanguage('desc')"></md-button>
          </md-input>
        </md-form-item>
        <md-form-item label="" v-for="item in descLanguageList" :key="item.model" style="margin-bottom: 0px">
          <md-input v-show="item.show" v-model="form[item.model]">
            <template slot="prepend">{{ item.label }}</template>
            <md-button slot="append" icon="md-icon-plus" @click="addLanguage('desc')"></md-button>
            <md-button slot="append" icon="md-icon-minus" @click="deleteLanguage(item)"></md-button>
          </md-input>
        </md-form-item>
      </md-form>
      <div style="margin-top: 20px; height: 30px">
        <md-button type="primary" style="float: right" @click="submitForm">确定</md-button>
        <md-button
          v-if="!readonly"
          style="float: right; margin-right: 10px"
          @click="
            () => {
              $emit('closeDialog');
            }
          "
        >
          取消
        </md-button>
      </div>
    </md-dialog>

    <!-- 选择图标弹框 -->
    <md-dialog
      v-dialogDrag
      :visible.sync="iconDialog.visible"
      top="50px"
      width="1000px"
      :title="iconDialog.title"
      :close-on-click-modal="true"
      append-to-body
    >
      <ul class="fas-icon-list">
        <li v-for="(item, index) in iconList" :key="index" @click="selectedIcon(item)">
          <i class="fas" :class="[item]" />
        </li>
      </ul>
    </md-dialog>
  </div>
</template>
<script>
import iconList from './iconList.js';

export default {
  name: 'menuDialog',
  watch: {
    'form.menuNameEn'(val) {
      if (val) {
        this.nameLanguageList[0].show = true;
      }
    },
    'form.menuNameJp'(val) {
      if (val) {
        this.nameLanguageList[1].show = true;
      }
    },
    'form.descEn'(val) {
      if (val) {
        this.descLanguageList[0].show = true;
      }
    },
    'form.descJp'(val) {
      if (val) {
        this.descLanguageList[1].show = true;
      }
    },
  },
  data() {
    return {
      title: '新增菜单',
      visible: false,
      readonly: false,
      form: {
        type: '1',
        parentCode: null,
        menuNameZh: null,
        menuNameEn: null,
        menuNameJp: null,
        menuCode: null,
        menuUrl: null,
        iconUrl: null,
        sort: null,
        status: 'Y',
        descZh: null,
        descEn: null,
        descJp: null,
        menuType: 'menu',
      },
      rules: {
        type: [{ required: true, message: '请选择菜单类型', trigger: 'change' }],
        menuNameZh: [{ required: true, message: '请输入菜单名称', trigger: 'change' }],
        menuCode: [{ required: true, message: '请输入唯一标识', trigger: 'change' }],
        menuUrl: [{ required: true, message: '请输入菜单链接', trigger: 'change' }],
        // iconUrl: [{ required: true, message: '请输入菜单图标', trigger: 'change' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'change' }],
      },

      nameLanguageList: [
        { model: 'menuNameEn', label: 'English', show: false },
        { model: 'menuNameJp', label: '日本语', show: false },
      ],
      descLanguageList: [
        { model: 'descEn', label: 'English', show: false },
        { model: 'descJp', label: '日本语', show: false },
      ],

      // 图标弹框
      iconDialog: {
        visible: false,
        title: '图标选择器',
      },
      iconList: iconList,
    };
  },
  methods: {
    // -------------------菜单名称-----------------
    // 增加语言
    addLanguage(type) {
      let listName = '';
      if (type === 'name') {
        listName = 'nameLanguageList';
      } else {
        listName = 'descLanguageList';
      }
      if (this[listName][0].show) {
        this[listName][1].show = true;
      } else {
        this[listName][0].show = true;
      }
    },
    // 删除语言
    deleteLanguage(row) {
      row.show = false;
      this.form[row.model] = '';
    },

    // -------------------图标选择-----------------
    iconChoose() {
      this.iconDialog.visible = true;
    },
    selectedIcon(iconName) {
      this.form.iconUrl = iconName;
      this.iconDialog.visible = false;
    },

    // -------------------按钮-----------------
    beforeClose() {
      this.$emit('closeDialog');
    },
    // 确认
    submitForm() {
      if (this.readonly) {
        this.$emit('closeDialog');
        return;
      }
      if (!this.form.menuUrl) {
        if (this.form.type === '1') {
          this.form.menuUrl = '菜单';
        }
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('sbmitForm', this.form);
        }
      });
    },

    handleChangeMenuType(e) {
      if (e === '1') {
        this.form.menuUrl = '菜单';
      } else {
        this.form.menuUrl = this.form.menuUrl === '菜单' ? '' : this.form.menuUrl;
      }
    },
  },
};
</script>

<style lang="less">
.my-form {
  width: 100%;
  .md-input {
    padding-bottom: 10px;
  }
  .el-input-group__prepend {
    width: 70px;
    text-align: center;
    padding: 0 4px;
  }
  .el-input-group__append {
    width: 50px;
    text-align: center;
    padding: 0 4px;
    button {
      border: none;
      background: rgba(0, 0, 0, 0);
      padding: 0;
      // margin-right: 8px;
      &:hover {
        background: rgba(0, 0, 0, 0);
        color: rgb(127, 127, 253);
      }
    }
  }
  .el-form-item__label {
    width: 110px;
  }
  .el-form-item__content {
    padding-left: 110px;
  }
  .md-col {
    .el-form-item__content {
      padding-left: 0;
    }
  }
  .el-date-editor.el-input {
    width: auto;
  }
  .line {
    text-align: center;
  }
  .el-form-item:last-child {
    margin-bottom: 0;
  }
  .el-form-item__error {
    left: 100px;
  }
  .mdDatePicker + .el-form-item__error,
  .md-time-picker + .el-form-item__error {
    left: 0;
  }
  .md-select {
    .el-input__inner {
      width: 360px;
    }
  }
  .md-textarea {
    width: 360px;
    .el-textarea__inner {
      height: 120px;
    }
  }
  .el-checkbox .el-checkbox__label {
    padding-left: 4px;
  }
}

// 图标弹框相关
.fas-icon-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.fas-icon-list li {
  margin: 10px 10px;
}
.fas {
  font-size: 30px;
  color: #000000;
  cursor: pointer;
}
</style>